<template>
    <div class="root-node-container" :data-exec-mode="execMode">
        <!-- Modo visualização -->
        <template v-if="execMode == gConsts.rt.execModes.VIEW">
            <div class="root-node-header">
                <span class="root-node-number">{{ orderNumber }}</span>
                <span class="root-node-title">{{ node.report.text || node.layout.caption }}</span>
            </div>
            <div class="root-node-content">
                <template v-if="id == 'step_denticao'">
                    <p class="root-node-content-text" v-if="selectedDenticaoReportNode">{{ selectedDenticaoReportNode.reportText }}</p>
                </template>

                <section class="root-node-children" v-if="layerChildren.length > 0">
                    <layerNodeCMP v-for="child in layerChildren" 
                        :key="child.id" :node="child" :execMode="execMode" 
                        :activeNode="activeNode ? activeNode.layer == child.id ? activeNode : null : null" 
                        :id="child.id">
                    </layerNodeCMP>
                </section>

                <section class="root-node-children" v-if="labelChildren.length > 0">
                    <labelNodeCMP v-for="(child, index) in labelChildren" 
                    :key="child.id" :node="child" :reportNode="labelChildrenReportNodes[index]" :execMode="execMode"
                    :active="activeNode ? activeNode.label == child.id : false" :id="child.id"></labelNodeCMP>
                </section>
            </div>
        </template>

        <!-- Modo de edição (WORK) -->
        <template v-if="execMode == gConsts.rt.execModes.WORK">
            <expansionPanelUI @onExpandedChange="toggleActive" :expanded="isActive">
                <template #header>
                    <div class="root-node-header">
                        <span class="root-node-number">{{ orderNumber }}</span>
                        <span class="root-node-title">{{ node.layout.caption }}</span>
                    </div>
                </template>
                <template #content>
                    <template v-if="id == 'step_denticao'">
                        <!-- Tipo de dentição -->
                        <section class="denticao-section">
                            <label for="denticao-select" class="denticao-section-label">Dentição:</label>
                            <selectUI 
                                id="denticao-select"
                                :options="getDenticaoSelectItems" 
                                :defaultSelected="selectedDenticao"
                                @change="onTipoDenticaoChange"
                            />
                        </section>

                        <odontogramaCMP :node="node" :id="id"></odontogramaCMP>
                    </template>

                    <section class="root-node-children" v-if="layerChildren.length > 0">
                        <layerNodeCMP v-for="child in layerChildren" :key="child.id" :node="child" :execMode="execMode"
                        :activeNode="activeNode ? activeNode.layer == child.id ? activeNode : null : null" :id="child.id"></layerNodeCMP>
                    </section>

                    <section class="root-node-children" v-if="labelChildren.length > 0">
                        <labelNodeCMP v-for="(child, index) in labelChildren" 
                        :key="child.id" :node="child" :reportNode="labelChildrenReportNodes[index]" :execMode="execMode"
                        :active="activeNode ? activeNode.label == child.id : false" :id="child.id"></labelNodeCMP>
                    </section>
                </template>
            </expansionPanelUI>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import expansionPanelUI from '@/components/ui/expansionPanel.vue';
import selectUI from '@/components/ui/select/select.vue';
import odontogramaCMP from './odontograma.vue';
import layerNodeCMP from './layerNode.vue';
import labelNodeCMP from './labelNode.vue';

import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';

export default {
    name: 'rootNodeCMP',
    components: {
        expansionPanelUI,
        selectUI,
        odontogramaCMP,
        layerNodeCMP,
        labelNodeCMP
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        node: {
            type: Object,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        orderNumber: {
            type: Number,
            required: true
        },
        activeNode: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            gConsts: gConsts,
            isActive: this.activeNode != null,
            selectedDenticao: null
        }
    },

    methods: {

        toggleActive() {
            this.isActive = !this.isActive;

            evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.id, nodeType: gConsts.node.layout.types.STEP });
        },

        onTipoDenticaoChange(selectedValue) {
            this.selectedDenticao = selectedValue;
            this.$store.dispatch('ACT_reportNodes_setDenticaoNode', {
                nodeId: this.selectedDenticao
            });
        },
    },

    watch: {
        activeNode(newVal) {
            this.isActive = newVal != null;
        },
        GET_selectedDenticaoReportNode: {
            handler(newVal) {
                if (this.id == 'step_denticao') {
                    this.selectedDenticao = newVal?.id ?? null;
                }
            },
            deep: true
        }
    },

    computed: {
        ...mapGetters([
            'GET_filteredNodes',
            'GET_reportNodes',
            'GET_selectedDenticaoReportNode'
        ]),
        
        selectedDenticaoReportNode() {
            return this.GET_reportNodes.find(reportNode => reportNode.id == this.selectedDenticao);
        },

        getDenticaoSelectItems() {
            const tipoDenticaoNodes = this.GET_filteredNodes.filter(node => (node.layout.parent === 'layer_tipoDenticao'));
            return [
                { value: null, label: '[Indefinida]' },
                ...tipoDenticaoNodes.map(node => ({ value: node.id, label: node.layout.label }))
            ];
        },

        layerChildren() { 
            return this.GET_filteredNodes.filter(node => 
                (node.layout.parent === this.node.id) && node.layout.group == gConsts.node.layout.groups.FOLDER
            );
        },

        labelChildren() {
            if (this.id == 'step_livre') {
                return this.GET_filteredNodes.filter(node => (node.layout.parent === 'layer_anotsLivres'))
            }
            return [];
        },

        labelChildrenReportNodes() {
            return this.labelChildren.map(child => this.GET_reportNodes.find(reportNode => reportNode.id === child.id));
        }
    }
}
</script>

<style scoped>

/* Modo visualização */

.root-node-container[data-exec-mode="view"] .root-node-header {
    gap: 5px;
}

.root-node-container[data-exec-mode="view"] .root-node-number {
    padding: 0;
    font-size: var(--text-md);
    font-weight: 700;
    color: #475569;
    background-color: transparent;
}

.root-node-container[data-exec-mode="view"] .root-node-title {
    font-size: var(--text-md);
    font-weight: 700;
}

.root-node-container[data-exec-mode="view"] .root-node-content {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 5px 10px;
}

.root-node-container[data-exec-mode="view"] .root-node-content-text {
    padding: 0;
    margin: 0;
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    font-weight: 400;
    color: #475569;
    text-align: left;
}

.root-node-container[data-exec-mode="view"] .root-node-children {
    gap: 0;
}


/* Modo de edição (WORK) */

.root-node-header {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.expansion-panel-header[data-expanded="true"] .root-node-number {
    color: white;
    background-color: #2B536A;
}
.expansion-panel-header[data-expanded="true"] .root-node-title {
    font-weight: 700;
    color: #2B536A;
}

.root-node-number {
    font-family: var(--font-family-primary);
    font-size: var(--text-xs);
    font-weight: 500;
    padding: 5px 10px;
    color: #64748B;
    background-color: #F1F5F9;
    border-radius: 8px;
    transition: all 0.2s ease-in-out;
}

.root-node-title {
    font-family: var(--font-family-primary);
    font-weight: 600;
    font-size: var(--text-md);
    color: #475569;
}

.root-node-children {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.denticao-section {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 5px;
    margin-bottom: 20px;
}


.denticao-section-label {
    font-family: var(--font-family-primary);
    font-size: var(--text-md);
    font-weight: 500;
    color: #475569;
    margin-top: -3px;
}
</style>